function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 1.77273C3.83691 1.77273 1.27273 4.33691 1.27273 7.5C1.27273 10.6631 3.83691 13.2273 7 13.2273C10.1631 13.2273 12.7273 10.6631 12.7273 7.5C12.7273 4.33691 10.1631 1.77273 7 1.77273ZM0 7.5C0 3.63401 3.13401 0.5 7 0.5C10.866 0.5 14 3.63401 14 7.5C14 11.366 10.866 14.5 7 14.5C3.13401 14.5 0 11.366 0 7.5ZM7 4.31818C7.35145 4.31818 7.63636 4.60309 7.63636 4.95455V6.86364H9.54545C9.89691 6.86364 10.1818 7.14855 10.1818 7.5C10.1818 7.85145 9.89691 8.13636 9.54545 8.13636H7.63636V10.0455C7.63636 10.3969 7.35145 10.6818 7 10.6818C6.64855 10.6818 6.36364 10.3969 6.36364 10.0455V8.13636H4.45455C4.10309 8.13636 3.81818 7.85145 3.81818 7.5C3.81818 7.14855 4.10309 6.86364 4.45455 6.86364H6.36364V4.95455C6.36364 4.60309 6.64855 4.31818 7 4.31818Z",
  fill: "#736DBA"
});

function SvgSxPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxPlusCircle);
export default __webpack_public_path__ + "static/media/sx-plus-circle.d21660f1.svg";
export { ForwardRef as ReactComponent };